import script from "./ProjectAuntNees.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectAuntNees.vue?vue&type=script&setup=true&lang=js"

import "./ProjectAuntNees.vue?vue&type=style&index=0&id=6aa39dd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa39dd4"]])

export default __exports__